import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import { Field, withDatasourceCheck, } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { useRouter } from 'next/router';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from 'react';
import { useAuth } from 'src/context/AuthProvider';
import axios from 'axios';
type RequestOpenDataProps = ComponentProps & {
  fields: {
    heading: Field<string>;
    FirstName: {
      value: string
    },
    Email: {
      value: string
    },
    MobileNumber: {
      value: string
    },
    RequiredDataSet: {
      value: string
    },
    ContentOfDataSet: {
      value: string
    },
    ButtonText: {
      value: string
    },
    Title: {
      value: string
    },
    SubTitle: {
      value: string
    },
    CaptchaRequiredText: {
      value: string
    },
    ContentDataRequiredText: {
      value: string
    },
    DataSetRequiredText: {
      value: string
    },
    EmailRequiredText: {
      value: string
    },
    FirstNameRequiredText: {
      value: string
    },
    InValidEmailText: {
      value: string
    },
    MinFirstNameLengthText: {
      value: string
    },
    MobileNumberRequiredText: {
      value: string
    },
    InvalidMobileNumber: {
      value: string
    },
    FormSuccessMessage: {
      value: string
    },
    FormFailedMessage: {
      value: string
    },
    ExpectedValueForDataSet: {
      value: string
    },
    ExpectedValueForDataSetValidationText: {
      value: string
    }

  };
  locale: string,
  lang: string
};

const RequestOpenData = (props: RequestOpenDataProps): JSX.Element => {
  const router = useRouter();
  const [captcha, setCaptcha]: any = useState(null);
  const { setMessage, setIsOpen }: any = useAuth();
  const [disable,setDisable]:any=useState(false);
  const sitekey: string = process.env.NEXT_PUBLIC_GOOGLE_CAPTCHA_API_KEY || ""
  const requestForm = useFormik({
    initialValues: {
      FirstName: '',
      Email: "",
      MobileNumber: "",
      DataSet: "",
      Content: "",
      ExpectedValueForDataSet: ""
    },
    validationSchema: Yup.object({
      FirstName: Yup.string().required(props?.fields?.FirstNameRequiredText?.value).min(3, props?.fields?.MinFirstNameLengthText?.value),
      Email: Yup.string().email(props?.fields?.InValidEmailText?.value).required(props?.fields?.EmailRequiredText?.value),
      MobileNumber: Yup.number().required(props?.fields?.MobileNumberRequiredText?.value),
      DataSet: Yup.string().required(props?.fields?.DataSetRequiredText?.value),
      Content: Yup.string().required(props?.fields?.ContentDataRequiredText?.value),
      ExpectedValueForDataSet: Yup.string().required(props?.fields?.ExpectedValueForDataSetValidationText?.value)
    }),
    onSubmit: async (values) => {
      if (captcha!=null) {
        setDisable(true);
        try {
          const body = {
            "FirstName": values.FirstName,
            "Email": values.Email,
            "MobileNumber": values.MobileNumber,
            "RequiredDataSet": values.DataSet,
            "RequiredDataSetContent": values.Content,
            "ExpectedValue": values.ExpectedValueForDataSet,
            "Language": props?.locale,
            "CaptchaResponse":captcha
          }
          setIsOpen(false);
          await axios({
            url: process.env.NEXT_PUBLIC_SITECORE_REST + "/api/Qiyas/QiyasOpenData",
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': props.locale
            },
            data: body
          });
        requestForm.resetForm();
          setMessage({ code: 200, message: props?.fields?.FormSuccessMessage.value });
          setDisable(false)
          setIsOpen(true);

        } catch (err) {
          setMessage({ code: 400, message: props?.fields?.FormFailedMessage.value });
          setDisable(false)
          setIsOpen(true);
        }
      } else {
        setMessage({ code: 400, message: props?.fields?.CaptchaRequiredText?.value })
        setIsOpen(true);
      }
    }
  })

  const CAPTCHA = (value: any) => {
    if (value) {
      setCaptcha(value);
    } else {
      setCaptcha(null);
    }
  }
  return (
    <div className={`responsive lg:py-40 py-28 ${props?.locale == "ar" ? 'rtl' : ''}`}>
      <div className='flex gap-2 -ml-[6px] items-center'>
        <ChevronLeftIcon onClick={() => { router.back() }} className={` cursor-pointer w-7 h-7 ${props?.locale == "ar" && "rotate-180"}`}
          aria-hidden="true"
        />
        <h1 className={`text-[42px] text-brand-100 font-bold `}>{props.fields?.Title?.value}</h1>
      </div>

      <div>
        <h1 className={`text-[28px] text-[#003141] font-bold  lg:mt-11 mt-8 mb-8`}>{props.fields.SubTitle.value}</h1>
      </div>


      <div>
        <form onSubmit={requestForm.handleSubmit}>
          <div className='grid lg:grid-cols-2 grid-cols-1 gap-8'>
            <div className='col-span-1'>
              <label className='text-[16px] text-[#2E2E2E] font-medium inline-block'>{props?.fields?.FirstName.value}</label>
              <input className={`${requestForm.touched.FirstName && requestForm.errors.FirstName && 'border border-red-500'} mt-3  w-full input-theme-color1 ${props?.locale == props?.lang ? "text-right pr-8" : "text-left"}`} name="FirstName" onBlur={requestForm.handleBlur} onChange={requestForm.handleChange} value={requestForm.values.FirstName} placeholder={props?.fields?.FirstName?.value} />
              {requestForm.touched.FirstName && requestForm.errors.FirstName && <div className="error">{requestForm.errors.FirstName}</div>}
            </div>
            <div className='col-span-1'>
              <label className='text-[16px] text-[#2E2E2E] font-medium inline-block'>{props?.fields?.Email.value}</label>
              <input className={`${requestForm.touched.Email && requestForm.errors.Email && 'border border-red-500'} mt-3  w-full input-theme-color1 ${props?.locale == props?.lang ? "text-right pr-8" : "text-left"}`} name="Email" onBlur={requestForm.handleBlur} onChange={requestForm.handleChange} value={requestForm.values.Email} placeholder={props?.fields?.Email?.value} />
              {requestForm.touched.Email && requestForm.errors.Email && <div className="error">{requestForm.errors.Email}</div>}
            </div>

            <div className='col-span-1'>

              <label className='text-[16px] text-[#2E2E2E] font-medium inline-block'>{props.fields.MobileNumber.value}</label>
              <PhoneInput
                international={false}
                defaultCountry="SA"

                className={`${requestForm.values.MobileNumber ? (isValidPhoneNumber(requestForm.values.MobileNumber) === true ? '' : 'border border-red-500') : ''} ${requestForm.touched.MobileNumber && requestForm.errors.MobileNumber && 'border border-red-500'} mt-3  w-full input-theme-color1 ${props?.locale == props?.lang ? "text-right pr-8" : "text-left"} `} name="MobileNumber" onBlur={requestForm.handleBlur} onChange={(e) => { requestForm.setFieldValue('MobileNumber', e) }} value={requestForm.values.MobileNumber} placeholder={props.fields.MobileNumber.value}
              />
              {requestForm.touched.MobileNumber && requestForm.errors.MobileNumber && <div className="error">{requestForm.errors.MobileNumber}</div>}
              <div className='error'> {`${requestForm.values.MobileNumber ? (isValidPhoneNumber(requestForm.values.MobileNumber) === true ? '' : props.fields.InvalidMobileNumber.value) : ''}`}</div>

            </div>
            <div className='col-span-1'>
              <label className='text-[16px] text-[#2E2E2E] font-medium inline-block'>{props?.fields?.RequiredDataSet.value}</label>
              <input className={`${requestForm.touched.DataSet && requestForm.errors.DataSet && 'border border-red-500'} mt-3  w-full input-theme-color1 ${props?.locale == props?.lang ? "text-right pr-8" : "text-left"}`} name="DataSet" onBlur={requestForm.handleBlur} onChange={requestForm.handleChange} value={requestForm.values.DataSet} placeholder={props?.fields?.RequiredDataSet?.value} />
              {requestForm.touched.DataSet && requestForm.errors.DataSet && <div className="error">{requestForm.errors.DataSet}</div>}
            </div>


            <div className='lg:col-span-2 col-span-1'>
              <label className='text-[16px] text-[#2E2E2E] font-medium inline-block'>{props?.fields?.ContentOfDataSet.value}</label>
              <textarea className={`${requestForm.touched.Content && requestForm.errors.Content && 'border border-red-500'} min-h-[183px]  mt-3  w-full input-theme-color1 ${props?.locale == props?.lang ? "text-right pr-8" : "text-left"}`} name="Content" onBlur={requestForm.handleBlur} onChange={requestForm.handleChange} value={requestForm.values.Content} placeholder={props?.fields?.ContentOfDataSet.value}></textarea>
              {requestForm.touched.Content && requestForm.errors.Content && <div className="error">{requestForm.errors.Content}</div>}
            </div>

            <div className='lg:col-span-2 col-span-1 mb-4'>
              <label className='text-[16px] text-[#2E2E2E] font-medium inline-block'>{props?.fields?.ExpectedValueForDataSet.value}</label>
              <input className={`${requestForm.touched.ExpectedValueForDataSet && requestForm.errors.ExpectedValueForDataSet && 'border border-red-500'} mt-3  w-full input-theme-color1 ${props?.locale == props?.lang ? "text-right pr-8" : "text-left"}`} name="ExpectedValueForDataSet" onBlur={requestForm.handleBlur} onChange={requestForm.handleChange} value={requestForm.values.ExpectedValueForDataSet} placeholder={props?.fields?.ExpectedValueForDataSet?.value} />
              {requestForm.touched.ExpectedValueForDataSet && requestForm.errors.ExpectedValueForDataSet && <div className="error">{requestForm.errors.ExpectedValueForDataSet}</div>}
            </div>
          </div>
          <div className='my-4 flex lg:flex-row flex-col lg:gap-8 gap-4 item-center'>
            <ReCAPTCHA
              sitekey={sitekey}
              onChange={CAPTCHA}
              hl={props.locale}
            />
            <button type='submit' disabled={disable} className={`bg-[#91B9B4] lg:py-0 py-4 text-[18px] px-6 text-white ${disable&&"opacity-50"}`}>{props.fields?.ButtonText?.value}</button>
          </div>
        </form>
      </div>

    </div>
  )
}


export default withDatasourceCheck()<RequestOpenDataProps>(RequestOpenData);
